import { render } from "./VacationRules.vue?vue&type=template&id=4ed19b68&scoped=true"
import script from "./VacationRules.vue?vue&type=script&lang=js"
export * from "./VacationRules.vue?vue&type=script&lang=js"

import "./VacationRules.vue?vue&type=style&index=0&id=4ed19b68&lang=less&scoped=true"
import "./VacationRules.vue?vue&type=style&index=1&id=4ed19b68&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed19b68"]])

export default __exports__